import React, { useEffect, useRef, useState } from "react";

const ACCENT = "#06B6D4";

const IconClose = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const IconCheckCircle = ({ size = 38, color = ACCENT }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <circle cx="12" cy="12" r="10" /><polyline points="8 12 11 15 16 9" />
  </svg>
);
export const IconWhatsApp = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.33 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.12h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.12.82.83-3.04-.19-.31a8.2 8.2 0 0 1-1.26-4.36c0-4.54 3.69-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.17 8.17 0 0 1 2.41 5.82c0 4.54-3.7 8.2-8.24 8.2zm4.52-6.16c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.56.12-.17.25-.64.8-.78.96-.14.17-.29.19-.53.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.23-1.46-1.37-1.7-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.42-.14-.01-.31-.01-.47-.01-.17 0-.44.06-.67.31-.23.25-.87.85-.87 2.08s.89 2.41 1.01 2.58c.12.17 1.76 2.68 4.25 3.76.6.26 1.06.41 1.43.53.6.19 1.14.16 1.57.1.48-.07 1.46-.6 1.67-1.17.2-.58.2-1.07.14-1.17-.06-.11-.22-.17-.47-.29z"/>
  </svg>
);

export default function PostActionDialog({
  visible,
  title,
  subtitle,
  photoUri,
  onShare,
  onClose,
  sharing,
  autoCloseMs = 30000,
  sharePrompt,
  shareLabel = "WhatsApp",
}) {
  const [secondsLeft, setSecondsLeft] = useState(Math.round(autoCloseMs / 1000));
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!visible) return;

    clearInterval(intervalRef.current);
    clearTimeout(timeoutRef.current);

    if (!autoCloseMs) return;

    setSecondsLeft(Math.round(autoCloseMs / 1000));

    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    timeoutRef.current = setTimeout(() => {
      onClose && onClose();
    }, autoCloseMs);

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, autoCloseMs]);

  if (!visible) return null;

  const progressPct = autoCloseMs
    ? Math.max(0, Math.min(100, (secondsLeft / Math.round(autoCloseMs / 1000)) * 100))
    : 100;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');

        .pad-backdrop {
          position: fixed; inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex; align-items: flex-end; justify-content: center;
          z-index: 1000;
          font-family: 'Plus Jakarta Sans', sans-serif;
          animation: padFadeIn 0.2s ease-out;
        }
        @keyframes padFadeIn { from { opacity: 0; } to { opacity: 1; } }

        .pad-card {
          width: 100%; max-width: 420px;
          background: #fff;
          border-radius: 28px 28px 0 0;
          padding: 10px 20px 28px;
          display: flex; flex-direction: column; align-items: center;
          position: relative;
          animation: padSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }
        @keyframes padSlideUp { from { transform: translateY(40px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @media (min-width: 480px) {
          .pad-backdrop { align-items: center; }
          .pad-card { border-radius: 28px; }
        }

        .pad-handle {
          width: 40px; height: 4px; border-radius: 2px;
          background: #E2E8F0; margin-bottom: 14px;
        }
        .pad-close-btn {
          position: absolute; top: 14px; right: 16px;
          width: 30px; height: 30px; border-radius: 15px;
          background: #F1F5F9; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
        }
        .pad-close-btn:hover { background: #E2E8F0; }

        .pad-icon-wrap {
          width: 64px; height: 64px; border-radius: 32px;
          background: rgba(6, 182, 212, 0.1);
          border: 1px solid rgba(6, 182, 212, 0.3);
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 10px;
        }
        .pad-title { font-size: 17px; font-weight: 800; color: #0F172A; margin: 0; }
        .pad-subtitle { font-size: 12.5px; font-weight: 600; color: #94A3B8; margin: 2px 0 14px; }

        .pad-photo {
          width: 100%; height: 200px;
          border-radius: 18px;
          background: #E2E8F0;
          object-fit: cover;
        }

        .pad-progress-track {
          width: 100%; height: 4px; border-radius: 2px;
          background: #F1F5F9; margin-top: 14px; overflow: hidden;
        }
        .pad-progress-fill {
          height: 100%; background: ${ACCENT}; border-radius: 2px;
          transition: width 1s linear;
        }
        .pad-countdown-text {
          font-size: 11px; font-weight: 600; color: #94A3B8; margin-top: 6px;
        }
        .pad-share-prompt {
          font-size: 13px; font-weight: 700; color: #0F172A;
          text-align: center; margin-top: 14px;
        }

        .pad-action-row { display: flex; gap: 10px; width: 100%; margin-top: 18px; }
        .pad-share-btn {
          flex: 1;
          background: #25D366;
          border: none; border-radius: 25px;
          display: flex; align-items: center; justify-content: center; gap: 6px;
          padding: 13px; cursor: pointer;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 700; color: #fff;
          transition: opacity 0.2s;
        }
        .pad-share-btn:hover:not(:disabled) { opacity: 0.9; }
        .pad-share-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .pad-cancel-btn {
          margin-top: 14px; padding: 6px;
          background: none; border: none; cursor: pointer;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px; font-weight: 700; color: #94A3B8;
        }
        .pad-cancel-btn:hover { color: #64748B; }

        @keyframes padSpin { to { transform: rotate(360deg); } }
        .pad-spinner {
          width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: padSpin 0.7s linear infinite;
        }
      `}</style>

      <div className="pad-backdrop" onClick={() => onClose && onClose()}>
        <div className="pad-card" onClick={(e) => e.stopPropagation()}>
          <div className="pad-handle" />

          <button className="pad-close-btn" onClick={() => onClose && onClose()}>
            <IconClose />
          </button>

          <div className="pad-icon-wrap">
            <IconCheckCircle />
          </div>

          <p className="pad-title">{title}</p>
          {subtitle ? <p className="pad-subtitle">{subtitle}</p> : null}

          {photoUri ? <img className="pad-photo" src={photoUri} alt="captured" /> : null}

          {autoCloseMs ? (
            <>
              <div className="pad-progress-track">
                <div className="pad-progress-fill" style={{ width: `${progressPct}%` }} />
              </div>
              <p className="pad-countdown-text">Closing in {secondsLeft}s</p>
            </>
          ) : null}

          {sharePrompt ? <p className="pad-share-prompt">{sharePrompt}</p> : null}

          <div className="pad-action-row">
            <button className="pad-share-btn" onClick={onShare} disabled={sharing}>
              {sharing ? <div className="pad-spinner" /> : <IconWhatsApp />}
              {shareLabel}
            </button>
          </div>

          <button className="pad-cancel-btn" onClick={() => onClose && onClose()}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}
